import { Box, Tab, Tabs } from "@mui/material";

export interface ResponsiveStatusTab<T extends string> {
  value: T;
  label: string;
  mobileLabel: string;
  count: number;
}

export function ResponsiveStatusTabs<T extends string>({
  value,
  items,
  onChange
}: {
  value: T;
  items: ResponsiveStatusTab<T>[];
  onChange: (value: T) => void;
}) {
  const compact = items.length <= 4;
  const tabs = (mobile: boolean) => items.map((item) => (
    <Tab key={item.value} value={item.value} label={mobile ? (
      <Box component="span" sx={{ display: "flex", flexDirection: "column",
        alignItems: "center", lineHeight: 1.05, fontSize: 11.5,
        whiteSpace: "nowrap" }}>
        <Box component="strong" sx={{ fontSize: 13 }}>{item.count}</Box>
        {item.mobileLabel}
      </Box>
    ) : `${item.label} (${item.count})`} />
  ));
  return (
    <>
      <Box sx={{ display: { xs: "block", sm: "none" }, flexShrink: 0 }}>
        <Tabs value={value} onChange={(_, next: T) => onChange(next)}
          variant={compact ? "fullWidth" : "scrollable"}
          scrollButtons="auto" allowScrollButtonsMobile sx={{
            minHeight: 54,
            "& .MuiTabs-flexContainer": { alignItems: "stretch" },
            "& .MuiTab-root": { minWidth: compact ? 0 : 96,
              flexShrink: 0, minHeight: 54, px: .75 }
          }}>
          {tabs(true)}
        </Tabs>
      </Box>
      <Box sx={{ display: { xs: "none", sm: "block" }, flexShrink: 0 }}>
        <Tabs value={value} onChange={(_, next: T) => onChange(next)}
          variant="scrollable" scrollButtons="auto" sx={{ minHeight: 48 }}>
          {tabs(false)}
        </Tabs>
      </Box>
    </>
  );
}
